module.exports = __webpack_public_path__ + "files/eaf4a6aaa22a22520496b67f3ff63016.png";